module.exports = __webpack_public_path__ + "static/img/makeDefaultCollection.8e080df4.gif";